module.exports = __webpack_public_path__ + "static/media/activity-icon-claim-rewards.f2107deb.svg";